import React from "react";

const ChillerTruckCoverage = ({ title, description, dubaiZones, sharjahZones, note, image, imageAlt, eastCoastTitle, eastCoastDescription, eastCoastZones }) => {
  return (
    <section className="ct-coverage-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          <p>{description}</p>
        </div>

        <div className="row g-4 align-items-start">
          {/* Dubai Zones */}
          <div
            className="col-lg-4 col-md-6"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-once="true"
          >
            <div className="ct-coverage-card">
              <div className="ct-coverage-card-header">
                <i className="bi bi-geo-alt-fill"></i>
                <span>Dubai Logistics Zones</span>
              </div>
              <ul className="ct-coverage-list">
                {dubaiZones.map((zone, i) => (
                  <li key={i}>
                    <strong>{zone.title}</strong> — {zone.description}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Sharjah Zones */}
          <div
            className="col-lg-4 col-md-6"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-once="true"
          >
            <div className="ct-coverage-card">
              <div className="ct-coverage-card-header">
                <i className="bi bi-geo-alt-fill"></i>
                <span>Sharjah Logistics Zones</span>
              </div>
              <ul className="ct-coverage-list">
                {sharjahZones.map((zone, i) => (
                  <li key={i}>
                    <strong>{zone.title}</strong> — {zone.description}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* East Coast / Fujairah Zones */}
          {eastCoastZones && (
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-delay="150"
              data-aos-once="true"
            >
              <div className="ct-coverage-card">
                <div className="ct-coverage-card-header">
                  <i className="bi bi-geo-alt-fill"></i>
                  <span>{eastCoastTitle}</span>
                </div>
                {eastCoastDescription && (
                  <p className="ct-coverage-card-desc">{eastCoastDescription}</p>
                )}
                <ul className="ct-coverage-list">
                  {eastCoastZones.map((zone, i) => (
                    <li key={i}>
                      <strong>{zone.title}</strong> — {zone.description}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>

        {note && (
          <p
            className="ct-coverage-note"
            data-aos="fade-up"
            data-aos-delay="150"
            data-aos-once="true"
          >
            {note}
          </p>
        )}
      </div>
    </section>
  );
};

export default ChillerTruckCoverage;
